import { Injectable, inject } from '@angular/core';
import { ExhibitionFacade } from '@app/exhibition/exhibition.facade';
import { StationFacade } from '@app/station/station.facade';
import { TourFacade } from '@app/tour/tour.facade';
import { combineLatest, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppService } from './app.service';
import { v4 as uuidv4 } from 'uuid';
import { MatomoTracker } from 'ngx-matomo-client';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {
    private readonly exhibitionFacade = inject(ExhibitionFacade);
    private readonly tourFacade = inject(TourFacade);
    private readonly stationFacade = inject(StationFacade);
    private readonly appService = inject(AppService);
    private readonly matomoTracker = inject(MatomoTracker);


    private readonly selectedExhibition$ = this.exhibitionFacade.selected$;
    private readonly selectedTour$ = this.tourFacade.selected$;
    private readonly selectedStation$ = this.stationFacade.selected$;

    private exhibitionTourStationSubscription: Subscription;

    public trackEvent(category: string, action: string, name?: string, value?: number) {
        this.matomoTracker.trackEvent(category, action, name, value);
    }

    public generateUserId(){
        this.setUserId(uuidv4());
    }

    private setUserId(userId: string) {
        this.appService.setUserId(userId);
        this.matomoTracker.setUserId(userId);
    }

    public setUserIdOnMatomo(userId: string) {
        this.matomoTracker.setUserId(userId);
    }

    public setDocumentTitle(documentTitle: string) {
        this.matomoTracker.setDocumentTitle(documentTitle);
    }

    public setDocumentTitleOnRouteChange() {
        this.exhibitionTourStationSubscription = combineLatest(
            [this.selectedExhibition$, this.selectedTour$, this.selectedStation$]
        )
            .subscribe(([selectedExhibition, selectedTour, selectedStation]) => {
                const exhitionTitle = selectedExhibition?.name;
                let tourTitle = selectedTour?.title['de'];
                const stationTitle = selectedStation?.title['de'];

                if (stationTitle && tourTitle) {
                    tourTitle += ',';
                }

                const combinedDocumentTitle = `${exhitionTitle ? exhitionTitle : ''} ${tourTitle ? tourTitle : ''} ${stationTitle ? stationTitle : ''}`;
                this.setDocumentTitle(combinedDocumentTitle);
            });
    }

    public stopSetDocumentTitleOnRouteChange() {
        this.exhibitionTourStationSubscription?.unsubscribe();
    }

    public setDocumentTitleWithExhibitionTitle(documentTitle: string) {
        this.selectedExhibition$
            .pipe(
                take(1)
            ).subscribe(exhibition => {
                const documentTitleWithExhibitionName =
                    `${exhibition && exhibition.name ? exhibition.name + ' ' : ''}${documentTitle}`;
                this.setDocumentTitle(documentTitleWithExhibitionName);
            });
    }

    public setSiteId(id: number) {
        this.matomoTracker.setSiteId(id);
    }

    public setTrackerUrl(url: string) {
        this.matomoTracker.setTrackerUrl(url);
    }

}
